import $ from 'jquery';
import LoginSignup from '@shared/modal-login-signup';
import { T_ } from '@shared/translation';
import { backToSignupSourcePage, isLoginSignup, onFreemarket,
  onAffiliatesHiremePage, hideConfirmPassword, CTS202VarM, onContest,
  redirectToPcpAfterEmployerSignup, redirectToGotoUrl, gotoUrl, showSignup,
  showLogin, preFillSignupForm,
  isLocalProject, project_id } from 'server-data/login-signup';
import '@shared/facebook-connect';

/**
 * This module contains the logic to initialise the login/signup modal that is
 * contained in `@shared/modal-login-signup`.
 **/


// set page as sign up source page for future redirection back
// If no local storage supported, we will ignore this redirection
if ('sessionStorage' in window && backToSignupSourcePage) {
  sessionStorage.setItem('signupSourcePage', window.location.href);
}

let loginOptions;
let signupOptions;
let loginClbk = false;
let employerSignupClbk = false;
let workerSignupClbk = false;

if (!onFreemarket) {
  loginOptions = { isLoginSignup };
  signupOptions = { isLoginSignup };

  if (hideConfirmPassword) {
    signupOptions.hideConfirmPassword = true;
  }

  if (CTS202VarM) {
    signupOptions.toggleableShowPassword = true;
    signupOptions.useSecurityPrompts = true;
    signupOptions.hidePasswordErrorMsg = true;
  }
} else {
  loginOptions = {
    title: T_('Login to Freemarket.com'),
    hideFacebook: true,
    hideLookingFor: true,
    isLoginSignup,
  };

  signupOptions = {
    loginTitle: T_('Login to Freemarket.com'),
    hideFacebook: true,
    hideLookingFor: true,
    isLoginSignup,
  };

  loginClbk = () => location.reload();
  employerSignupClbk = () => location.reload();
  workerSignupClbk = () => location.reload();
}

if (onAffiliatesHiremePage) {
  loginClbk = () => {
    window.location = gotoUrl;
  };
}

if (onContest) {
  loginClbk = () => {
    location.reload();
  };

  if (redirectToPcpAfterEmployerSignup) {
    employerSignupClbk = () => {
      _t.push(['abtest', {
        test: 'RedirectToPcpAfterEmployerSignup',
        variation: 'variation',
      }]);

      location.href = '/contest/create.php';
    };
  } else {
    employerSignupClbk = () => {
      _t.push(['abtest', {
        test: 'RedirectToPcpAfterEmployerSignup',
        variation: 'original',
      }]);

      location.reload();
    };
  }

  workerSignupClbk = () => {
    location.reload();
  };
}

if (redirectToGotoUrl && gotoUrl) {
  employerSignupClbk = () => { window.location = gotoUrl; };
  workerSignupClbk = () => { window.location = gotoUrl; };
  loginOptions.gotoUrl = gotoUrl;
}

const loginSignup = new LoginSignup({
  el: isLoginSignup ? $('#login_form_container') :
    $('#default-modal-placeholder'),
  loginClbk,
  employerSignupClbk,
  workerSignupClbk,
  isLocalProject,
  projectId: project_id,
});

$('#login-normal').click((e) => {
  e.preventDefault();
  loginSignup.showLogin(loginOptions);
  loginSignup.setBackdrop();
});

$('#sign-up').click((e) => {
  e.preventDefault();
  loginSignup.showSignup(signupOptions);
  loginSignup.setBackdrop();
});

if (isLoginSignup) {
  if (showSignup) {
    if (preFillSignupForm) {
      signupOptions.saveFormFields = true;
    }

    loginSignup.showSignup(signupOptions);
  } else {
    loginSignup.showLogin(loginOptions);
  }
}

if (showLogin) {
  $('#login-normal').trigger('click');
}
